<template>   
    <div class="main">
     <img  src="static/img/act/1/bg.jpg"  />
      <div class="act-1-link"  >
        <router-link :to="{ path: '/act1/main/newslist', query: { type: 1 , cid: 200, idArray: '63288,63293,62396,63420'}}">
          <img src="static/img/act/1/1.png?v=1"  />
        </router-link> 
        <router-link :to="{ path: '/act1/main/newslist', query: { type: 2 , cid: 200, idArray: '63289,57652,63299'}}">
        <img src="static/img/act/1/2.png?v=1" />
        </router-link> 
        <router-link :to="{ path: '/act1/main/newslist', query: { type: 3 , cid: 200, idArray: '63096,61002,62764,63127,63422,63460'}}">
        <img src="static/img/act/1/3.png?v=1" />
        </router-link> 
        <router-link :to="{ path: '/act1/main/newslist', query: { type: 4 , cid: 200, idArray: '62803,62936,61000,62934'}}">
        <img src="static/img/act/1/4.png?v=1"  />
        </router-link> 
        <router-link :to="{ path: '/act1/main/newslist', query: { type: 5 , cid: 200, idArray: '63130,63295,56628'}}">
        <img src="static/img/act/1/5.png?v=1"  />
        </router-link> 
        <router-link :to="{ path: '/act1/main/newslist', query: { type: 6 , cid: 200, idArray: '63286,60904,59944,59942'}}">
        <img src="static/img/act/1/6.png?v=1" />
        </router-link> 
        <router-link :to="{ path: '/act4/main/news', query: { id: 63287}}">
        <img src="static/img/act/1/7.png?v=1" />
        </router-link> 
      </div>
    </div>  
</template>

<script> 

  export default {
    name: 'Act1Main',
    components: {  
    },
    data() {
      return {  
      }
    }, 
    destroyed(){ 
    },
    mounted() { 
    },
    created() {
      //页面设置
      this.setDocumentV2(
        "2019春节闲游宝典", 
        "",
        "https://z.lzgd.com.cn/inliuzhou/2018/LiuzhouTourism/img/share.jpg?v=2"
      );
      _czc.push(['_trackEvent', '2019春节闲游宝典', '点击', '主页面','0','1']); 
    },
    methods: {
    }
  }
</script>

<style scoped>

  .main{
    position: absolute;
    width: 100%;
    height: calc(100% - 1.37rem);
    font-size: 0;
    overflow-x: hidden;
    overflow-y: scroll;
  }
  .main img{
    width: 100%;
  }

.act-1-link{
  position: absolute;
  left:9%;
  top: 12%;
  width: 82%;
  height: 15%; 
}
.act-1-link img{
  width: 100%;
  margin-top: 4%;
}  
</style>


// WEBPACK FOOTER //
// src/components/act/1/main.vue